import apiClient from "@repo/ui/lib/apiClient";
import type { ApiResponse } from "@repo/ui/types";
import type { BookingDetails } from "@repo/ui/types/booking";

export interface AddBaggageToBookingInStateBody {
  baggages: {
    name: string;
    quantity: number;
    ssrCode: string;
    ssrKey: string;
    passengerKey: string;

    // staff entitlement (explicit) for 1$ CLP fot Pet on Board
    isStaffEntitled?: boolean;
    staffEntitledAmount?: number;
  }[];
  currency: string;
  isUserStaff: boolean;
}

export type AddBaggageToBookingInStateResponse = ApiResponse<BookingDetails | null>;

export async function addBaggageToBookingInState(
  payload: AddBaggageToBookingInStateBody,
  tabSessionId: string | null,
): Promise<AddBaggageToBookingInStateResponse> {
  const url = "/v1/bookings/baggages";

  const response = await apiClient<AddBaggageToBookingInStateResponse>(url, {
    method: "POST",
    headers: {
      accept: "application/json",
    },
    body: payload,
    withAuth: true,
    tabSessionId,
  });

  if (!response) {
    throw new Error(`Failed to add baggages to booking in-state: ${response}`);
  }

  return response;
}
